// extracted by mini-css-extract-plugin
module.exports = {"slider":"GalleryImages_slider__qKZNc"};